import { cn } from '@/shared/lib'

export type StatusTone = 'ok' | 'warn' | 'danger' | 'info' | 'accent' | 'muted'

interface StatusBadgeProps {
  tone: StatusTone
  label: string
  className?: string
}

const tones: Record<StatusTone, { text: string; dot: string }> = {
  ok: { text: 'text-ok', dot: 'bg-ok' },
  warn: { text: 'text-warn', dot: 'bg-warn' },
  danger: { text: 'text-danger', dot: 'bg-danger' },
  info: { text: 'text-info', dot: 'bg-info' },
  // Текст акцентом не красим: на card/raise он не добирает 4.5:1 — читаемый
  // сосед акцента в токен-слое это link, точка остаётся акцентной.
  accent: { text: 'text-link', dot: 'bg-accent' },
  muted: { text: 'text-muted', dot: 'bg-faint' },
}

export function StatusBadge({ tone, label, className }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-raise py-0.5 pl-2 pr-2.5 text-caption font-medium',
        tones[tone].text,
        className,
      )}
    >
      <span className={cn('size-1.5 rounded-full', tones[tone].dot)} aria-hidden="true" />
      {label}
    </span>
  )
}
